import cn from 'classnames';
import {useHistory} from 'react-router-dom';
import './layout.sass';

type TProps = {children: React.ReactNode};

function Layout({children}: TProps) {
  const history = useHistory();
  console.log('history', history.location);
  return (
    <div className="layout">
      <div
        className={cn('layout__inner', {
          _transparent: history.location.pathname.split('/').pop() === 'embed',
        })}
      >
        <div className="layout__body">
          {/* <div className="layout__header">
            <Header />
          </div> */}
          <div className="layout__page">{children}</div>
        </div>
        {/* <div className="layout__footer">
          <a href="https://gagarin.world" target="_blank" rel="noreferrer">
            by gagarin.world
          </a>
        </div> */}
        {/* <div className="layout__footer">
          <Footer />
        </div> */}
      </div>
    </div>
  );
}

export default Layout;
